import { render, staticRenderFns } from "./InventBomRouteView.vue?vue&type=template&id=4ad53086&scoped=true"
import script from "./InventBomRouteView.vue?vue&type=script&lang=js"
export * from "./InventBomRouteView.vue?vue&type=script&lang=js"
import style0 from "./InventBomRouteView.vue?vue&type=style&index=0&id=4ad53086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad53086",
  null
  
)

export default component.exports